import styled from 'styled-components';
import { LinkBase } from '../LinkBase/LinkBase';
import { createShouldForwardProp } from '../utils';
import { LinkColor } from './Link.constants';
export const LinkRoot = styled(LinkBase).withConfig({
  shouldForwardProp: createShouldForwardProp(['linkColor'])
}).withConfig({
  componentId: "ds__sc-tdkcn8-0"
})(["color:", ";font-weight:", ";font-size:inherit;font-family:", ";text-decoration:none;&:hover,&:focus{color:", ";text-decoration:underline;}"], _ref => {
  let {
    theme: {
      Link
    },
    linkColor
  } = _ref;
  return Link.LINK_COLOR_TO_COLOR[linkColor] || Link.LINK_COLOR_TO_COLOR[LinkColor.SECONDARY_CONTRAST];
}, props => props.theme.Link.fontWeight, props => props.theme.fontFamilyPrimary, _ref2 => {
  let {
    theme: {
      Link
    },
    linkColor
  } = _ref2;
  return Link.LINK_COLOR_TO_HOVER_COLOR[linkColor] || Link.LINK_COLOR_TO_HOVER_COLOR[LinkColor.SECONDARY_CONTRAST];
});